import GetFetch from '../common/GetFetch';

const Fetcher = (day) => {
    const URI = `dashboard/summary/daily/${day}`;

    return GetFetch(URI);
}


export default Fetcher;